import React from 'react';
import {connect} from 'react-redux';
import bbqIcon from '../../../resources/images/icons/barbecue.svg';
import Loading from '../../../components/common/Loading/Loading';
import styles from './CommentsPage.css';
import style from '../../../styles/styles';
import Error from "../../../components/common/Error/Error";
import {fetchApp} from "../../../store/apps/actions";
import {acceptComment, getComments, rejectComment} from "../../../store/comments/actions";
import {Dialog, FlatButton} from "material-ui";
import Comment from "../../../components/comment/Comment/Comment";
import withTranslation from "../../../hoc/withTranslation";
import CommentService from '../../../services/comment';

export class CommentsPage extends React.Component {

    state = {
        commentToReject: null,
        openRejectComment: false,
        commentToAccept: null,
        openAcceptComment: false
    };

    componentWillMount() {
        this.fetchApplication();

        if (this.props.app) {
            this.props.getComments(this.props.app.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }

        if (this.props.sending && !nextProps.sending) {
            this.handleCloseRejectComment();
            this.handleCloseAcceptComment();
        }

        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getComments(nextProps.app.id);
        }
    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    // Reject common

    handleRejectComment = (comment) => {
        this.setState({
            openRejectComment: true,
            commentToReject: comment
        });
    };

    handleCloseRejectComment = () => {
        this.setState({
            openRejectComment: false,
            commentToReject: null
        });
    };

    rejectComment = () => {
        this.props.rejectComment(this.props.app.id, this.state.commentToReject);
    };

    // Accept common

    handleAcceptComment = (comment) => {
        this.setState({
            openAcceptComment: true,
            commentToAccept: comment
        });
    };

    handleCloseAcceptComment = () => {
        this.setState({
            openAcceptComment: false,
            commentToAccept: null
        });
    };

    acceptComment = () => {
        this.props.acceptComment(this.props.app.id, this.state.commentToAccept);
    };

    // Render

    renderEmptyView() {
        return (
            <div style={styles.empty.fullHeight}>
                <div className="row" style={styles.empty.container}>
                    <div>
                        <div className="center-xs col-xs-12">
                            <img style={styles.empty.image} src={bbqIcon} alt="empty"/>
                        </div>
                        <div style={styles.empty.textContainer}
                             className="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                            <span style={styles.empty.title}>
                                {this.props.t('module.comment.no_comment')}
                            </span><br/><br/>
                            <span style={styles.empty.desc}>
                                {this.props.t('module.comment.no_comment_to_manage')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderRejectCommentDialog(comment) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseRejectComment}
            />,
            <FlatButton
                label={this.props.t('generic.reject')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.rejectComment}
            />
        ];
        const text = CommentService.getTextForComment(
            this.props.t,
            comment,
            'module.comment.reject_comment_confirmation'
        );
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.comment.reject_comment')}
                    modal={this.props.sending}
                    open={this.state.openRejectComment}
                    onRequestClose={this.handleCloseRejectComment}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{ __html: text }}/>
                </p>
                }
            </Dialog>
        );
    }

    renderAcceptCommentDialog(comment) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseAcceptComment}
            />,
            <FlatButton
                label={this.props.t('generic.accept')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.acceptComment}
            />
        ];
        const text = CommentService.getTextForComment(
            this.props.t,
            comment,
            'module.comment.accept_comment_confirmation'
        );
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.comment.moderate')}
                    modal={this.props.sending}
                    open={this.state.openAcceptComment}
                    onRequestClose={this.handleCloseAcceptComment}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{ __html:text }}/>
                </p>
                }
            </Dialog>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false}/>;
        }

        if (this.props.comments.length === 0) {
            return (
                <div>
                    {this.renderEmptyView()}
                </div>
            );
        }

        return (
            <div>
                {this.state.commentToReject && this.renderRejectCommentDialog(this.state.commentToReject)}
                {this.state.commentToAccept && this.renderAcceptCommentDialog(this.state.commentToAccept)}

                <h3 style={style.navigation}>{this.props.t('generic.application')} / {this.props.t('module.comment.name')} - {this.props.app.name}</h3>

                {this.props.comments.map(comment => (
                    <Comment
                        key={comment.id}
                        user={this.props.user}
                        comment={comment}
                        handleAcceptComment={this.handleAcceptComment}
                        handleRejectComment={this.handleRejectComment}
                    />
                ))}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        sending: state.comments.sending,
        app: state.apps.currentApplication,
        loading: state.apps.pending || state.comments.pending,
        comments: state.comments.content,
        user: state.auth.content
    };
}

export default connect(mapStateToProps, {
    acceptComment,
    rejectComment,
    getComments,
    fetchApp
})(withTranslation(CommentsPage));



// WEBPACK FOOTER //
// src/containers/comments/CommentsPage/CommentsPage.js